import React, { useEffect, useState } from 'react';
import { Alert, Button, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Col, Icon } from '../Component';
import TextInput from '../../pages/components/inputs/TextInput';

const YesNoModal = ({ openModal, setOpenModal, modalTitle, modalDescription, succFunc, buttonConfirm, buttonCancel, errAmend, setErrAmend, textInput, textInputLabel }) => {

 const [modal, setModal] = useState(false);
 const [loading, setLoading] = useState(false);
 const [errorVal, setError] = useState("");
 const [title, setTitle] = useState("");
 const [description, setDescription] = useState("");
 const [textInputValue, setTextInputValue] = useState("");

 useEffect(() => {
  setError(errAmend);
  if (errAmend)
  {
   setLoading(false);
  }
 }, [errAmend]);

 useEffect(() => {
  setModal(openModal);
  setErrAmend("");
  setLoading(false);
  setDescription(modalDescription);
  setTitle(modalTitle);
 }, [openModal]);

 useEffect(() => {
  setDescription(modalDescription);
 }, [modalDescription]);

 useEffect(() => {
  setTitle(modalTitle);
 }, [modalTitle]);

 const toggleModal = () => {
  cancleClick();
 };

 // Cancel and Confirm Functions
 const confirmClick = () => {
  setLoading(true);
  succFunc(textInputValue);
  setErrAmend("");
 };

 const cancleClick = () => {
  setOpenModal(false);
  setErrAmend("");
 };

 const handleChange = (e) => {
  setTextInputValue(e.target.value);
 };


 return (
  <>
   <Modal isOpen={modal} toggle={!loading && (toggleModal)}>
    <ModalHeader
     toggle={!loading && (toggleModal)}
    >
     {title}
    </ModalHeader>
    <ModalBody>
     {errorVal && (
      <div className="mb-3 w-100">
       <Alert color="danger" className="alert-icon">
        <Icon name="alert-circle" /> {errorVal}{" "}
       </Alert>
      </div>
     )}
     <p>{description}</p>
     {
      textInput && (
       <>
        <TextInput
         colSize={12}
         label={textInputLabel}
         type="number"
         id_val="input"
         handleChange={handleChange}
         name="input"
         required
        />
       </>
      )
     }
     <Col xl="12" className="d-flex justify-between mt-4 mr-2">
      <Button onClick={cancleClick} className="btn-secondary">
       {
        buttonCancel
       }

      </Button>
      <Button onClick={confirmClick} disabled={loading || (textInput ? textInputValue === "" : false)} className=" btn-danger ">
       {loading ? <Spinner size="sm" /> : buttonConfirm}
      </Button>
     </Col>
    </ModalBody>
   </Modal>
  </>
 );
};

export default YesNoModal;